import React from 'react'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { NewReactRewrite } from './Components/NewReactRewrite'
import { LegacyKnockout } from './Components/LegacyKnockout'

/** Contains react rewrite feature fork */
export const RaceCardContent: React.FC<{
  /** Expect format YYYY-MM-DD */
  meetingDate: string
  meetingId: string
  raceNumber: string
}> = ({ meetingDate, meetingId, raceNumber }) => {
  const isReactRewriteFeatureActive = useFeature('race-card-react-rewrite')

  if (isReactRewriteFeatureActive) {
    return <NewReactRewrite />
  }

  return <LegacyKnockout meetingDate={meetingDate} meetingId={meetingId} raceNumber={raceNumber} />
}
